import React  from "react";
import logoWide from './../../media/Logo_KC21-wide.svg';
import logoShort from './../../media/Logo_KC21-short.svg';

function LogoKC21() {
  return (
    <div className="logo-kc21">
      <img src={logoWide} className="wide" alt="KC21 Logo" />
      <img src={logoShort} className="short" alt="KC21 Logo" />
    </div>
  );
}
export default LogoKC21;
